import { render, staticRenderFns } from "./TableContractsLease.vue?vue&type=template&id=afed913e"
import script from "./TableContractsLease.vue?vue&type=script&lang=js"
export * from "./TableContractsLease.vue?vue&type=script&lang=js"
import style0 from "./TableContractsLease.vue?vue&type=style&index=0&id=afed913e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports